// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_8o-0";